
import Vue from 'vue';

Vue.mixin({
    methods: {
        getPlatformBaseUrl(roleName) {
            if (['admin', 'admin_user'].indexOf(roleName) > -1) {
                return window.ADMIN_BASE_URL || '';
            } else if (['country_operation', 'country_sub'].indexOf(roleName) > -1) {
                return window.COUNTRY_BASE_URL || '';
            } else if (['seller', 'seller_sub'].indexOf(roleName) > -1) {
                return window.SELLER_BASE_URL || '';
            } else if (['jde_web'].indexOf(roleName) > -1) {
                return window.JDE_BASE_URL || '';
            } else if (['mmdc_web'].indexOf(roleName) > -1) {
                return window.MMDC_BASE_URL || '';
            }
            return window.PASSPORT_BASE_URL || '';
        }
    }
})
